import * as ContentItems from '@components/Widgets/_contentItems/all'
import draggable from 'vuedraggable'
import { mapActions } from 'vuex'

export default {
  name: 'ContentItems',
  components: {
    draggable,
  },
  computed: {
    targetWidgetType() {
      return this.$store.getters['campaign/widget/targetWidgetType']
    },
    basicContentItems() {
      return this.contentItems.filter((item) => {
        return item.category === 'basic'
      })
    },
    formContentItems() {
      return this.contentItems.filter((item) => {
        return item.category === 'form'
      })
    },
    otherContentItems() {
      return this.contentItems.filter((item) => {
        return item.category === 'other'
      })
    },
  },
  data() {
    return {
      contentItems: Object.values(ContentItems),
    }
  },
  methods: {
    ...mapActions('editor', ['setVisibleMenu']),
    onStart() {
      const contentRestrainers = document.querySelectorAll(
        '.content-item-dropzone')

      contentRestrainers.forEach(contentRestrainer => {
        contentRestrainer.classList.add('show-dropzone-indicator')
      })
    },
    onEnd() {
      const contentRestrainers = document.querySelectorAll(
        '.content-item-dropzone')

      contentRestrainers.forEach(contentRestrainer => {
        contentRestrainer.classList.remove('show-dropzone-indicator')
      })
    },
  },
}
